import { accordionAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(accordionAnatomy.keys);

const baseStyle = definePartsStyle({
  button: {
    fontSize: 'sm',
    lineHeight: '16px',
    _hover: {
      bg: 'inherit'
    },
    height: '40px'
  },
  container: {
    borderTopWidth: 0,
    _last: {
      borderBottomWidth: 0
    }
  },
  panel: {
    pt: 0,
    px: 4,
    pb: 4
  }
});

export const Accordion = defineMultiStyleConfig({
  baseStyle
});